/* eslint-disable jsx-a11y/anchor-is-valid */
/* import logo from "assets/img/footer/logo_sm_white.png";
import routes from '../../../../../sagepath/sagepath/main/src/app/app.routes';
const Footer = () => {
  return (
  <footer className="relative flex flex-col rounded-[10px] border-[1px] border-gray-200 bg-white bg-clip-border shadow-md shadow-[#F3F3F3] dark:border-[#ffffff33] dark:!bg-navy-800 dark:text-white dark:shadow-none w-full h-full px-6 pb-6 sm:overflow-x-auto">
    <div className=" max-w-screen-xl mx-auto p-4 md:py-8">
     <span className="flex justify-center text-gray-400">Designed By</span>
      <a href="https://www.thebytecloud.tech/" target="_blank" className="flex items-center mb-4 sm:mb-0 space-x-3 rtl:space-x-reverse" rel="noreferrer">
         <img src={logo}  className="h-9" alt="TheByteCloud LLC Logo" />
       </a>
       <span className="block text-sm text-gray-500 sm:text-center dark:text-gray-400">© {new Date().getFullYear()} All Rights Reserved.</span>
    </div>
  </footer>
 );
};

export default Footer;
 */

import {Footer, FooterTitle, FooterBrand, FooterCopyright, FooterDivider, FooterLink, FooterLinkGroup } from "flowbite-react";
import logo from "assets/img/footer/logo_sm_white.png";

const FooterComponent = () => {
  return (
 <Footer container>
      <div className="w-full">
        <div className="grid w-full justify-between sm:flex sm:justify-between md:flex md:grid-cols-1">
          <div className="relative size-32 ...">
      <div className="absolute bottom-0 left-0 size-15">
        <span className="align-right m-4 md:align-top text-gray-400 text-xs">Designed By</span>
           <FooterBrand
              href="https://www.thebytecloud.tech/" target="_blank"
              src={logo }
              alt="ByteCloud Logo"
            />
  </div>
</div>

          <div className="grid grid-cols-2 gap-8 sm:mt-4 sm:grid-cols-3 sm:gap-6 mb-3">
            <div>
              <FooterTitle title="Quick Links" />
              <FooterLinkGroup col>
                <FooterLink href="/"  className="font-medium text-blue-600 dark:text-blue-500">Dashboard</FooterLink>
                <FooterLink href="/admin/services"  className="font-medium text-blue-600 dark:text-blue-500">Our Services</FooterLink>
                <FooterLink href="/admin/profile"  className="font-medium text-blue-600 dark:text-blue-500">About</FooterLink>
              </FooterLinkGroup>
            </div>
             <div>
                  <h2 className="mb-6 text-sm font-semibold uppercase text-gray-500 dark:text-white">Contact Us</h2>
                  <ul className="text-gray-500 dark:text-gray-400 font-medium">
                      <li className="mb-2">
                          <a href="#" className="me-4 last:mr-0 md:mr-6 font-medium text-sm dark:text-blue-500 hover:no-underline">Email: ed@stemllc.net</a>
                      </li>
                      <li className="mb-2">
                          <a href="#" className="me-4 last:mr-0 md:mr-6 font-medium text-sm dark:text-blue-500 hover:no-underline">Phone: (201) 705-4925</a>
                      </li>
                       <li className="mb-2">
                          <a href="#" className="me-4 last:mr-0 md:mr-6 font-medium text-sm dark:text-blue-500 hover:no-underline">Hours: Mon-Fri 9AM-7PM</a>
                      </li>
                  </ul>
              </div>
          </div>
        </div>
        <FooterDivider />
        <div className="w-full sm:flex sm:items-center sm:justify-between">
          <FooterCopyright href="#" by="All Rights Reserved." year={new Date().getFullYear()} />
        </div>
      </div>
    </Footer>
        
  );
}
export default FooterComponent;